<script>
  // Перенос SectionHeader из lib/ui.tsx — Unbounded-титул + кикер/мета + хэйрлайн.
  // Простые кикер/мета — пропсами, сложная мета (с разметкой) — слотом "meta".
  export let title = '';
  export let kicker = undefined;
  export let meta = undefined;
  export let divider = true;
  export let centerLine = false;
  let className = '';
  export { className as class };
  export let style = undefined;
</script>

<div class={'ui-sechead' + (className ? ' ' + className : '')} {style}>
  {#if kicker != null}<div class="kick">{kicker}</div>{/if}
  <div class="row">
    <div class="ttl">{#if $$slots.title}<slot name="title" />{:else}{title}{/if}</div>
    {#if $$slots.meta || meta != null}
      <div class="meta">{#if $$slots.meta}<slot name="meta" />{:else}{meta}{/if}</div>
    {/if}
  </div>
  {#if divider}<div class={'ui-hairline' + (centerLine ? ' center' : '')}></div>{/if}
</div>
